import * as React from 'react'
import { Outlet } from 'react-router-dom'

import { CanImportTeamsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalImporterTeamsPage = () => {
  const { company, access } = useCurrentSession()

  const { data, loading, error } = useQuery(CanImportTeamsDocument, {
    fetchPolicy: 'network-only',
  })

  const canImportResources = data?.universalImporter._policies.importResources.can
  const canCreateTeams = data?.teams._policies.teamCreate.can

  const authorized = canImportResources && canCreateTeams
  const locale = access.locale

  return (
    <ResponsivePage.Body authorized={authorized} loading={loading} error={error} showHeader={false}>
      <NuvoImporter importType="teams_importer" locale={locale} companyId={company.id} />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default UniversalImporterTeamsPage
